import { useQuery, UseQueryResult } from '@tanstack/react-query';
import api from './api';
import { AxiosRequestConfig } from 'axios';

export const useGet = <T>(
  endpoint: string,
  config?: AxiosRequestConfig,
  enabled: boolean = true
): UseQueryResult<T> => {
  return useQuery<T>({
    queryKey: [endpoint, config],
    queryFn: async () => {
      try {
        const response = await api.get<T>(endpoint, config);
        return response.data;
      } catch (error: any) {
        if (error.response?.status === 401) {
          localStorage.clear();
          sessionStorage.clear();
          window.location.href = '/login';
        }
        throw error;
      }
    },
    enabled,
    staleTime: 0,
    retry: 1,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};
